let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("j2GwS"), load("e9stW"), load("2F69B"), load("keAJC")]).then(() => parcelRequire('eFf86'));